import type React from 'react';
import { Text, type TextProps } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'commons/utils';
import { useGetCurrency } from 'domains/Auth/hooks';

interface MoneyProps extends Omit<TextProps, 'children'> {
  readonly price: number;
  readonly currency?: string;
  readonly prefix?: string;
  readonly withoutDecimal?: boolean;
}

function Money({
  price,
  currency,
  prefix,
  withoutDecimal,
  ...textProps
}: Readonly<MoneyProps>): React.JSX.Element {
  const { code } = useGetCurrency();
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Text {...textProps}>
      {!!prefix && `${prefix} `}
      {formatCurrency(price, currency ?? code, language, withoutDecimal)}
    </Text>
  );
}

export default Money;
